var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUpDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.11038 6.00033H4.89038C5.99705 6.00033 6.44705 5.21699 5.89705 4.26033L5.65038 3.83366C5.59038 3.73033 5.48038 3.66699 5.36038 3.66699L2.64038 3.66699C2.52038 3.66699 2.41038 3.73033 2.35038 3.83366L2.10372 4.26033C1.55372 5.21699 2.00372 6.00033 3.11038 6.00033Z",
    fill: "#7CFF90"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M2.92953 3.33319H5.07286C5.20286 3.33319 5.28286 3.19319 5.2162 3.08319L5.00286 2.71652C4.45286 1.75986 3.5462 1.75986 2.9962 2.71652L2.78286 3.08319C2.71953 3.19319 2.79953 3.33319 2.92953 3.33319Z",
    fill: "#7CFF90"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpDark);
export default __webpack_public_path__ + "static/media/arrow-up-dark.a02f4384bc513abd9f4c15b569c41629.svg";
export { ForwardRef as ReactComponent };